import Icon from '../Icon.vue'

Icon.register({
  'home': {
    width: 16,
    height: 16,
    paths: [
      {
        d: 'M9.985 16c-.584 0-.992-.461-.992-1.143L9 11H7.015l-.008 3.857c-.004.676-.41 1.143-.992 1.143H3.037c-.582 0-.988-.467-.993-1.143V9.778l-.926-.04c-.437 0-.902-.123-1.06-.595C-.1 8.668.082 7.94.404 7.597L7.255.322c.404-.43 1.022-.43 1.427-.001l6.912 7.317c.326.343.507 1.03.347 1.505-.16.472-.557.635-.993.635h-.992v5.08c0 .68-.408 1.142-.993 1.142'
      }
    ]
  }
})
